import { mapState } from 'pinia';
import { usePageStore } from '@/store';
import thridRegister from '../../mixins/thrid-register';
import { leadTypes } from '@/common/const';

export default {
    mixins: [thridRegister],
    inject: ['destroy'],
    props: {
        type: {
            type: String,
            default: ''
        },
        options: {
            type: Object,
            default: () => ({})
        },
        changeAllowClose: Function
    },
    data: function() {
        return {
            showThirdNext: this.options.showThirdNext || false,
            registerData: this.options.registerData,
            isAutoRegister:
                this.options.isAutoRegister === false
                    ? this.options.isAutoRegister
                    : true
        };
    },
    computed: {
        ...mapState(usePageStore, ['page']),
        role({ page }) {
            return this.options.role || page.registerUserType || leadTypes.Buyer;
        },
        showFacebook({ page }) {
            return (
                (this.options.showFacebook === undefined
                    ? true
                    : this.options.showFacebook) && !page.wordPressSSR
            );
        },
        showGoogle({ page }) {
            return (
                (this.options.showGoogle === undefined
                    ? true
                    : this.options.showGoogle) && !page.wordPressSSR
            );
        },
        toastMsg() {
            return this.options.toast || '';
        },
        ignorPhone() {
            if (this.role === leadTypes.buyer) {
                return this.options.ignoreBuyerPhone === undefined
                    ? this.ignoreBuyerPhone
                    : this.options.ignoreBuyerPhone;
            } else {
                return this.options.ignoreSellerPhone === undefined
                    ? this.ignoreSellerPhone
                    : this.options.ignoreSellerPhone;
            }
        }
    },
    methods: {
        thirdPartyOnLogin() {
            this.onThirdPartCallback(
                this.options.onLogin,
                this.options.isLoginToast,
                'Login successfully!'
            );
            this.destroy();
        },
        //  Executed after the third party logs in 
        thirdPartyRegisterNext(data) {
            this.thridPartFormatDate(data, this.options.formatData).then(_ => {
                return this.thirdPartyRegister(data)
            });
        },
        //  call internal register third-party/register interface to get user after the data 
        thirdPartyOnRegister() {
            this.onThirdPartCallback(this.options.onregister, false);
            if (this.isFbLead) {
                this.onThirdPartCallback(
                    this.options.onsuccess,
                    true,
                    this.toastMsg
                );
                this.destroy();
            } else if (this.ignorPhone) {
                //  Log in or register with a third party ， When phone is optional ， direct finish No longer need to show login registration box 
            
                this.thirdRegisterSubmitSuccess({});
                this.destroy();
            } else {
                this.showThirdNext = true;
                this.changeAllowClose(false);
            }
        },
        showThirdPartyRegister() {
            this.showThirdNext = true;
            this.changeAllowClose(false);
        },
        thirdShowQuestionnaire() {
            if (!this.ignorPhone) {
                this.onThirdPartCallback(this.options.onregister, false);
            }
            if (this.inquiry) {
                const type = this.role === leadTypes.seller ? 1 : 0;
                const options = Object.assign(
                    {},
                    this.options.questionnaire || {},
                    {
                        noToast: true,
                        closeCallback: () => {
                            this.onThirdPartCallback(
                                this.options.onsuccess,
                                true,
                                this.toastMsg
                            );
                        }
                    }
                );
                this.thirdOpenQuestionnaire(options, type);
            } else {
                this.onThirdPartCallback(
                    this.options.onsuccess,
                    true,
                    this.toastMsg
                );
                this.destroy();
            }
        }
    }
};
